import React, { useEffect, useState } from "react";
import t, { changeLanguage } from "../../../components/I18N/TranslateHelpers";
import { GetCurrentLocale, pathname } from "../../../components/Utils";
import {
  buttonForWishlist,
  buttonHtmlViewProduct,
  getFirstImageProduct,
  productExistsInWishlist,
} from "../../../components/UtilsForCart";
import { SpinnerOnTop } from "../../../components/SpinnerOnTop";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/RootReducer";
import ProductPrice from "../ProductPrice/ProductPrice";


interface ComponentProps {
  userAccount: any;
  productItem: any;
  isRequestingAdd: boolean;
  productIdRequest: number;
  setProductIdRequest: any;
}

const ProductThumbView: React.FC<ComponentProps> = ({
                                                      userAccount,
                                                      productItem,
                                                      isRequestingAdd,
                                                      productIdRequest,
                                                      setProductIdRequest,
                                                    }: ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale);

  const dispatch = useDispatch();
  const [isInWishlist, setIsInWishlist] = useState(false);
  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);

  useEffect(() => {
    if (userAccount && productItem) {
      if (productExistsInWishlist(productItem.id, userAccount.favouriteProducts)) {
        setIsInWishlist(true);
      }
    }
  }, [userAccount, productItem]);

  const isPageSearch = pathname === "/" + locale + t("url_search");

  return (
    <div
      className={!isPageSearch ? "col-lg-4 col-md-6 col-sm-12 mb-4" : "col-lg-3 col-md-3 col-sm-12 mb-4"}
      key={productItem.id}
    >
      <figure className="card card-product-grid height100">
        <div className="img-wrap">
          <a
            href={
              "/" + locale + t("url_detail_product") + "/" + productItem.slug + "?variant=" + productItem.reference
            }
          >
            <img src={getFirstImageProduct(productItem, false)} alt={productItem.name} />
          </a>
        </div>

        <a
          href={
            "/" + locale + t("url_detail_product") + "/" + productItem.slug + "?variant=" + productItem.reference
          }
          className="info-wrap border-top px-3"
        >
          <span className="title h5"> {productItem.name} </span>
          <div className="price-wrap">
            <strong className="price">{productItem.brand.name}</strong>
            <span className="reference-product">{productItem.reference}</span>
          </div>
        </a>

        <div className="px-3 pb-3">
          <ProductPrice productItem={productItem} mode="catalog" />
        </div>

        <div className="row align-items-center px-3 pb-3">
          <div className="col-auto nopaddingr">
            {buttonHtmlViewProduct(productItem.slug, locale, productItem.reference)}
          </div>
          <div className="col favorite-icon-col">
            {isRequestingAdd && productIdRequest === productItem.id ? (
              <div className="float-end mr-5 pr-5 mb-2">
                <SpinnerOnTop />
              </div>
            ) : isAuthenticated ? (
              buttonForWishlist(
                !isInWishlist,
                dispatch,
                productItem.id,
                setIsInWishlist,
                setProductIdRequest
              )
            ) : null}
          </div>
        </div>
      </figure>
    </div>
  );
};

export default ProductThumbView;
